import { useRouter } from "next/router";
import { Button, Modal } from "@aqar-app/react-ui";
import css from "@/src/pages/add-listing/daily/.module.scss";
import { ACTIONS_MAP } from "@/common/ACTIONS_MAP";

export function AddListingPopup({ buttons, message_ar, title_ar, onNext }) {
  const router = useRouter();
  return (
    <Modal.ClassicOverlay dir="rtl" className={css.popup}>
      <div className={css.header}>
        <h3>{title_ar}</h3>
        <Modal.CloseButton />
      </div>
      <div className={css.body}>
        <p>{message_ar}</p>
      </div>
      <div className={css.footer}>
        {buttons.map((button, i) => (
          <Button
            {...(ACTIONS_MAP[button]?.props || {
              theme: "primary",
            })}
            key={i}
            onClick={(e) => {
              const { route, target } = ACTIONS_MAP[button];

              if (route) {
                if (target) {
                  return window.open(route, target);
                }
                return router.push(route).then(() => {
                  Modal.close(e);
                });
              }

              if (button === "EXIT_ADD_LISTING") {
                return Modal.close(e);
              }
              if (button === "NEXT") {
                return onNext(e);
              }
            }}
          >
            {ACTIONS_MAP[button].label?.ar}
          </Button>
        ))}
      </div>
    </Modal.ClassicOverlay>
  );
}
